module.exports = __webpack_public_path__ + "images/6adb9705ab9312c0b368fb7265b1e704.jpg";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/test2.jpg
// module id = 135
// module chunks = 0